//  url for check if available feature on backend
export const featuresApi = process.env.REACT_APP_BACKEND_URL + "/operation/v1/features";

// url for grey log
export const graylogApi = process.env.REACT_APP_BACKEND_URL + "/operation/v1/logs";

// url for dynamic price layer
export const dynamicPriceLayer = process.env.REACT_APP_RPC + "/get-point-dynamic-price-layers";
